import { render } from "./SettlementModal.vue?vue&type=template&id=18f3689e"
import script from "./SettlementModal.vue?vue&type=script&lang=js"
export * from "./SettlementModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__